import { get, getapi, putapi1, uploadimage, del1, put as put1, post } from './fetch'
import { colorMap } from './map'
export function FETCH_LIST_DATA ({ commit, dispatch }, { type }) {
  commit('FETCHING_LISTS')
  return () => {
    return true
  }
}
export async function USER_DATA ({ commit, dispatch }) {
  try {
    const user = await get('me')
    await dispatch('RoleMap')
    // console.log('USER_DATA', user)
    commit('setUser', user)
    commit('setDefaultStore', user.defaultStore)
    dispatch('setTheme', user.theme)
  } catch (err) {
    commit('setIsLoggedIn', false)
  }
}

export async function uploadFile ({ commit }, { event, folder }) {
  commit('setFetching', true)
  const r = await uploadimage(event, folder)
  await setTimeout(async () => {
    commit('setFetching', false)
  }, 500)
  return r
}
export async function checkLogin ({ commit, state, dispatch }) {
  try {
    const result = await get('isloggedIn')
    console.log('checkLogin', result)
    if (result) {
      await dispatch('RoleMap')
      await dispatch('USER_DATA')
      const restaurants = await getapi('restaurantSetting/all')
      const countries = await getapi('selections/country')
      const vipName = await getapi('selections/vipName')
      commit('setCountries', countries)
      commit('setVipName', vipName)
      commit('setRestaurants', restaurants)
      commit('setIsLoggedIn', true)
      connectSocket(state.user._id)
      return true
    } else {
      commit('setIsLoggedIn', false)
      return false
    }
  } catch (err) {
    commit('setIsLoggedIn', false)
    console.log('[ERROR][setIsLoggedIn]', err)
    return false
  }
}
const { io } = require('socket.io-client')
function onConnect () {
  console.log('socket connect')
}

function onDisconnect () {
  console.log('socket onDisconnect')
}
function connectSocket (id) {
  if (global.socket) {
    console.log('socket is connected ? ', global.socket.connected)
    global.socket.disconnect()
    global.socket.query = { userId: id }
    global.socket.connect()
    return true
  } else {
    console.log('connectSocket', `${location.protocol === 'http:' ? 'ws' : 'wss'}://${location.host}/v2/web/socket.io/`, location.protocol, location.protocol === 'http:' ? 'ws' : 'wss')
    const socket = io(
      `${location.protocol === 'http:' ? 'ws' : 'wss'}://${location.host}`,
      { path: '/v2/web/socket.io/', query: { userId: id } }
    )
    global.socket = socket
    // console.log('connectSocket', 'wss://cmcp1885.siotek.dev/v2/web/socket.io/')
    // const socket = io('wss://localhost:3001/v2/web/socket.io/')
    socket.on('connect', onConnect)
    socket.on('disconnect', onDisconnect)
    socket.on('ping', (error) => {
      console.log('socket ping error', error)
    })
    return true
  }
}
export async function RoleMap ({ commit, dispatch }) {
  try {
    const roles = await getapi('selections/roles')
    commit('setRoleMap', roles)
  } catch (err) {
    commit('setRoleMap', [])
  }
}
export async function save ({ commit }, { url, body }) {
  try {
    // console.log('save')
    commit('setFetching', true)
    const result = await post(url, body)
    commit('setFetching', false)
    return result
  } catch (err) {
    commit('setFetching', false)
    // console.log(err)
    return false
  }
}
export async function create ({ commit }, { url, body }) {
  try {
    // console.log('create')
    commit('setFetching', true)
    const result = await put1(url, body)
    commit('setFetching', false)
    return result
  } catch (err) {
    commit('setFetching', false)
    // console.log(err)
    return false
  }
}

export async function del ({ commit }, { url }) {
  try {
    commit('setFetching', true)
    const result = await del1(url)
    commit('setFetching', false)
    return result
  } catch (err) {
    commit('setFetching', false)
    return false
  }
}
export async function put ({ commit }, { url, body }) {
  try {
    commit('setFetching', true)
    const result = await putapi1(url, body)
    commit('setFetching', false)
    return result
  } catch (err) {
    commit('setFetching', false)
    return false
  }
}
export function setTheme (state, theme) {
  // console.log('setTheme')
  // console.log(theme, theme ? colorMap(theme) : theme)
  if (theme) {
    document.body.style.setProperty('--color-pri', colorMap(theme).pri)
    document.body.style.setProperty('--color-checked', colorMap(theme).checked)
    document.body.style.setProperty('--color-infobox', colorMap(theme).infobox)
    document.body.style.setProperty('--color-bar', colorMap(theme).infobox)
    document.body.style.setProperty('--color-selected', colorMap(theme).infobox)
  }
}
export function SOCKET_MESSAGE (arg) {
  // console.log('SOCKET_MESSAGE', arg)
}
